import { createSelector } from '@reduxjs/toolkit';
import { getRightsList } from '../../../../../redux/rights/selectors';
import { Role } from '../roles';

export const isSCCCustomer = createSelector(getRightsList, (rightsList) =>
  rightsList.some((right) => right.name === Role.SCCCustomer)
);
export const isSCCService = createSelector(getRightsList, (rightsList) =>
  rightsList.some((right) => right.name === Role.SCCService)
);
export const groupCompanySCCCustomer = createSelector(
  getRightsList,
  (rightsList) => {
    const role = rightsList.find((right) => right.name === Role.SCCCustomer);
    let groupId = undefined;
    if (role) {
      groupId = role.scope.split(':')[1];
    }
    return groupId;
  }
);
